import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";
import { IObjectKey } from "src/app/modules/shared/models/objects";

export const isv_search_form_template = {
    isvTaxCode: null
}

export const isv_search_form_validators = {
    isvTaxCode: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)]
}

export const isv_search_form_keys: IFormKey[] = [
    {
        id: 'isv-taxCode-field',
        label: 'Codice fiscale',
        controlName: 'isvTaxCode',
        uppercase: true
    }
];

export const searched_subject_keys: IObjectKey[] = [
    {
        label: 'Codice fiscale',
        key: 'taxCode'
    },
    {
        label: 'Data di nascita',
        key: 'birthDate',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        label: 'Tipologia',
        key: 'type'
    }
];